
<template>

    <div style="display:inline-block">
        &nbsp;
        <t-button class="Button" @click="OnPreviousButtonClick" :disabled="!PreviousButtonEnabled">&lt;</t-button>
        &nbsp;
        <t-button class="Button" @click="OnNextButtonClick" :disabled="!NextButtonEnabled">&gt;</t-button>

    </div>
</template>

<script scoped>
    import apiService from '@/Common/ApiService'
    import FormViewRequest from '@/Common/FormViewRequest'
    import Utility from '@/Common/Utility'
 



    export default {

        data() {
            return {
                KeyColumnNames: [],
                Id: null,
                tableName: "",
                listResponseData: null,

                PreviousButtonEnabled: true,
                NextButtonEnabled: true

            }
        }
        ,
        props: ["value", "Attribute", "KeyName","ListTableName"],


        computed: {



        }
        ,

        methods: {

            GetDetailPageUrl(valueSet) {
                let detailUrl = "";
                let baseFolderName;
                let i;


 
                if (valueSet == null) {
                    throw ("valueSet can not be null !");
                }

 
                if (window.location.href.indexOf("Detail") > 0) {
                    detailUrl = `/${this.tableName}/${this.tableName}Detail/`;
                }
                else {
                    //PROBLEM
                    //detailUrl = `/${this.tableName}/${this.tableName}View/`;
                    detailUrl = `/${this.tableName}/${this.tableName}Detail/`;
                }

                if (window.location.href.indexOf("/Backend") > 0) {
                    detailUrl = "/Backend" + detailUrl;
                }
                else {
                    baseFolderName = window.location.pathname.split("/")[1];

                    if (baseFolderName != "Product" && baseFolderName != this.tableName) {
                        detailUrl = `/${baseFolderName}` + detailUrl;
                    }
                    else {
                        detailUrl =  detailUrl;
                    }
                }

                detailUrl = Utility.PrefixUrl(detailUrl);

                //+ responseData.ValueSet[this.KeyColumnName]

                for (i = 0; i < this.KeyColumnNames.length; i++) {

                    detailUrl += valueSet[this.KeyColumnNames[i]];
                    if (i < this.KeyColumnNames.length - 1) {
                        detailUrl += ",";
                    }
                }

                return detailUrl;
            },


            OnPreviousButtonClick() {
                let rowData;
                let previousRowData;
                let matchRowIndex = -1;
                let formViewRequest;
                let pageCount = 0;
                let url;
                let i;


                for (i = 0; i < this.listResponseData.Rows.length; i++) {
                    rowData = this.listResponseData.Rows[i];

                    if (this.CompareValueSet(this.$parent.$data.ValueSet, rowData.ValueSet)) {
                        matchRowIndex = i;
                        break;
                    }
                }



                pageCount = Math.ceil(
                    this.listResponseData.Paging.TotalCount /
                    this.listResponseData.Paging.RecordPerPage
                );


                if (matchRowIndex > 0) {
                    previousRowData = this.listResponseData.Rows[matchRowIndex - 1];
                    this.QueryDetail(previousRowData)

                    url = this.GetDetailPageUrl(previousRowData.ValueSet);

                    this.$router.push(url);
                }
                else if (
                    (matchRowIndex == 0)
                    &&
                    this.listResponseData.Paging.CurrentPageNumber > 1
                ) {
                    this.listResponseData.Paging.CurrentPageNumber -= 1;


                    apiService.Post(`/api/${this.tableName}/List`, this.listResponseData).then(
                        (responseData) => {
                            this.listResponseData.Rows = responseData.Rows;

                            formViewRequest = responseData.Rows[responseData.Rows.length - 1];

                            return apiService.Post(`/api/${this.tableName}/Detail`, formViewRequest);
                        }
                    ).then(
                        function (responseData) {

                            url = this.GetDetailPageUrl(responseData.ValueSet);

                            //this.$router.push(`/${this.tableName}/${this.tableName}Detail/` + responseData.ValueSet[this.KeyColumnName]);
                            this.$router.push(this.GetDetailPageUrl(responseData.ValueSet));


                            Utility.SetNotNullAttributes(this, this.$parent.$data, responseData);
                            //Object.assign(this.$parent.$data, responseData);

                            this.PrepareMoveButtons();


                            this.$bus.$emit('RecordMoveButtonClick', {
                                Id: this.Id
                            });

                            this.$emit("move");

                        }.bind(this)
                    );
                }

            }
            ,


            OnNextButtonClick() {
                let rowData;
                let nextRowData;
                let formViewRequest;
                let matchRowIndex = -1;
                let pageCount;
                let i;
 

                for (i = 0; i < this.listResponseData.Rows.length; i++) {
                    rowData = this.listResponseData.Rows[i];

                    if (this.CompareValueSet(this.$parent.$data.ValueSet, rowData.ValueSet)) {
                        matchRowIndex = i;
                        break;
                    }
                }

                pageCount = Math.ceil(
                    this.listResponseData.Paging.TotalCount /
                    this.listResponseData.Paging.RecordPerPage
                );


                if (matchRowIndex >= 0) {
                    if (matchRowIndex < this.listResponseData.Rows.length - 1) {
                        nextRowData = this.listResponseData.Rows[matchRowIndex + 1];

                         
                        this.$router.push(this.GetDetailPageUrl(nextRowData.ValueSet));
                         
                        this.QueryDetail(nextRowData);
                    }
                    else if (
                        (matchRowIndex == this.listResponseData.Rows.length - 1)
                        &&
                        this.listResponseData.Paging.CurrentPageNumber < pageCount
                    ) {
                        this.listResponseData.Paging.CurrentPageNumber += 1;
 
                        apiService.Post("/api/" + this.tableName + "/List", this.listResponseData).then(
                            (responseData) => {
                                this.listResponseData.Rows = responseData.Rows;
                                formViewRequest = responseData.Rows[0];

                                //Utility.SaveSession(`${this.tableName}List`, responseData);

                                return apiService.Post("/api/" + this.tableName + "/Detail", formViewRequest);
                            }
                        ).then(
                            function (responseData) {

                                if (responseData.Latest != null) {
                                    //this.$router.push("/" + this.tableName + "/" + this.tableName + "Detail/" + responseData.Latest.ValueSet[this.KeyColumnName]);
                                    this.$router.push(this.GetDetailPageUrl(responseData.Latest));
                                }
                                else {
                                    //this.$router.push("/" + this.tableName + "/" + this.tableName + "Detail/" + responseData.ValueSet[this.KeyColumnName]);
                                    this.$router.push(this.GetDetailPageUrl(responseData.ValueSet));
                                }

                                //Utility.SaveSession(`${this.tableName}Detail`, responseData);

                                Utility.SetNotNullAttributes(this, this.$parent.$data, responseData);
                                //Object.assign(this.$parent.$data, responseData);

                                //if (responseData.Latest != null) {
                                //  this.$parent.$data.ValueSet.IssueNo = responseData.Latest.ValueSet.IssueNo;
                                //}


                                this.PrepareMoveButtons();

                                this.$emit("move");

                                this.$bus.$emit('RecordMoveButtonClick', {
                                    Id: this.Id
                                });
                            }.bind(this)
                        );
                    }
                }
            }
            ,


            QueryDetail(requestData) {
                Utility.ShowLoadingPicture(this);
                apiService.Post("/api/" + this.tableName + "/Detail", requestData).then(
                    function (responseData) {
                        let i;

                        Utility.HideLoadingPicture(this);

                        Utility.SetNotNullAttributes(this, this.$parent.$data, responseData);

                        if (responseData.Rows != null) {
                            for (i = 0; i < responseData.Rows.length; i++) {
                                responseData.Rows[i].ValueSet.SeqNo = (i + 1);
                            }
                        }


                        if (responseData.ValueSet != null) {
                            if (this.$parent.$data.ValueSet == null) {
                                this.$parent.$data.ValueSet = {};
                            }

                            Object.assign(this.$parent.$data.ValueSet, responseData.ValueSet);
                        }
                        if (responseData.AttributeSet != null) {
                            if (this.$parent.$data.AttributeSet == null) {
                                this.$parent.$data.AttributeSet = {};
                            }

                            Object.assign(this.$parent.$data.AttributeSet, responseData.AttributeSet);
                        }

                        this.PrepareMoveButtons();

                        this.$bus.$emit('RecordMoveButtonClick', {
                            Id: this.Id
                        });


                        this.$emit("move");

                        this.$emit("LoadResponse", responseData);
                    }.bind(this)
                );
            },


            PrepareMoveButtons() {
                let rowData;
                let matchRowIndex = -1;
                let pageCount;
                let i;


                if (this.$route.query.Action == "Create") {
                    this.PreviousButtonEnabled = false;
                    this.NextButtonEnabled = false;
                    return;
                }

                if (this.IsObjectEmpty(this.$parent.$data.ValueSet)) {
                    setTimeout(
                        function () {
                            this.PrepareMoveButtons();
                        }.bind(this)
                        ,
                        100
                    );

                    return;
                }


                 
                if (this.listResponseData == null) {
                    this.listResponseData = Utility.GetSession("" + this.tableName + "List");
                }

                if (this.listResponseData != null) {

                    for (i = 0; i < this.listResponseData.Rows.length; i++) {
                        rowData = this.listResponseData.Rows[i];

                        if (this.CompareValueSet(this.$parent.$data.ValueSet, rowData.ValueSet)) {
                            matchRowIndex = i;
                            break;
                        }
                    }
                }


                if (matchRowIndex < 0) {
                    this.PreviousButtonEnabled = false;
                    this.NextButtonEnabled = false;
                }
                else {

                    if (this.listResponseData.Paging.CurrentPageNumber == 1 &&
                        matchRowIndex == 0) {
                        this.PreviousButtonEnabled = false;
                    }
                    else {
                        this.PreviousButtonEnabled = true;
                    }

                    pageCount = Math.ceil(
                        this.listResponseData.Paging.TotalCount /
                        this.listResponseData.Paging.RecordPerPage
                    );


                    //最後一頁 最後一筆
                    if (
                        (this.listResponseData.Paging.CurrentPageNumber == pageCount) &&
                        (matchRowIndex == this.listResponseData.Rows.length - 1)
                    ) {
                        this.NextButtonEnabled = false;
                    }
                    else {
                        this.NextButtonEnabled = true;
                    }

                }
            }
            ,

            IsObjectEmpty(obj) {
                for (var key in obj) {
                    if (obj.hasOwnProperty(key))
                        return false;
                }

                return true;
            },

            CompareValueSet(detailValueSet, listValueSet) {
                let equal = true;
                let propertyName;
                let count = 0;
                let i;


                if (this.KeyColumnNames.length == 0) {
                    for (propertyName in listValueSet) {
                        if (detailValueSet.hasOwnProperty(propertyName) && listValueSet.hasOwnProperty(propertyName)) {
                            if (listValueSet[propertyName] == detailValueSet[propertyName]) {
                                count++;
                            }
                            else {
                                equal = false;
                                break;
                            }
                        }

                        if (count >= 5) {
                            break;
                        }
                    }
                }
                else {
                    for (i = 0; i < this.KeyColumnNames.length; i++) {
                        propertyName = this.KeyColumnNames[i];
                        if (detailValueSet.hasOwnProperty(propertyName) &&
                            listValueSet.hasOwnProperty(propertyName)
                        ) {
                            if (listValueSet[propertyName] == detailValueSet[propertyName]) {
                                equal = true;
                            }
                            else {
                                equal = false;
                                break;
                            }
                        }
                        else {
                            equal = false;
                            break;
                        }
                    }
                }


                return equal;
            }
        },

        mounted() {

        },

        beforeMounted() {

        },

        created() {
            let tableNameRegex = /([a-z|0-9|_]+)Detail/ig;
            let tableNameRegex2 = /([a-z|0-9|_]+)View/ig;
            let matches;


            if (this.ListTableName != null) {
                this.tableName = this.ListTableName;
            }
            else
            {
                matches = tableNameRegex.exec(window.location.href);
                if (matches != null && matches.length >= 2) {
                    this.tableName = matches[1];
                }
                else {
                    matches = tableNameRegex2.exec(window.location.href);
                    if (matches != null && matches.length >= 2) {
                        this.tableName = matches[1];
                    }
                }
            }


            if (this.KeyName == null) {
                this.KeyColumnNames = [this.tableName + "No"];
            }
            else {
                if (this.KeyName.indexOf(",") > 0) {
                    this.KeyColumnNames = this.KeyName.split(",");
                }
                else {
                    this.KeyColumnNames = [this.KeyName];
                }
            }

            if (this.Id == null) {
                this.Id = Utility.GenerateSerialNumber();
            }

            if (this.listResponseData == null) {
                this.listResponseData = Utility.GetSession(this.tableName + "List");

                setTimeout(
                    function () {
                        this.PrepareMoveButtons();
                    }.bind(this),
                    100
                );

                setTimeout(
                    function () {
                        this.PrepareMoveButtons();
                    }.bind(this),
                    1000
                );
            }

            this.$bus.$on('RecordMoveButtonClick',
                function (event) {
                    if (this.Id != event.Id) {
                        this.PrepareMoveButtons();
                    }
                }.bind(this)
            );
        }
        ,
        beforeDestroy: function () {
            // [銷毀監聽事件]
            // 最好在组件銷毀前，清除 specialEvent 所有監聽
            // 如果要指定哪個監聽對應方法，就需要傳入第二個參數(對應$on設定的方法)

            this.$bus.$off('RecordMoveButtonClick');
        },

        watch: {
            value: function (newVal, oldVal) {

            }
        }


    }
</script>

<style>
</style>
